export default __webpack_public_path__ + "static/media/emergencyLogo.3d650554.svg";